import { styled } from '@mui/material/styles';
import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';
import { ChangeEvent, forwardRef } from 'react';

export type ITextFieldProps = Omit<MuiTextFieldProps, 'name' | 'onChange' | 'ref' | 'defaultValue' | 'InputProps'> & {
    enableDOMAttributeRequired?: boolean;
    name: string;
    readOnly?: boolean;
    onChange?: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

const StyledTextField = styled(MuiTextField)(({ hidden }) => ({
    ...(hidden && { display: 'none' })
}));

export const TextField = forwardRef<HTMLDivElement, ITextFieldProps>(function InnerTextField(
    {
        autoComplete = 'off',
        enableDOMAttributeRequired = false,
        readOnly,
        required = false,
        size = 'small',
        value,
        onChange,
        ...props
    },
    ref
) {
    return (
        <StyledTextField
            {...props}
            ref={ref}
            autoComplete={autoComplete}
            required={required}
            size={size}
            value={value ?? ''}
            onChange={onChange}
            slotProps={{
                ...props.slotProps,
                input: {
                    ...props.slotProps?.input,
                    required: enableDOMAttributeRequired && required,
                    readOnly: readOnly ?? undefined
                }
            }}
        />
    );
});
